<template>
  <div class="relative">
    <transition
      v-if="slotPassed"
      enter-active-class="transition ease-out duration-200"
      enter-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-1"
    >
      <div v-show="openMenu || false" class="absolute z-50 -ml-12 transform px-2 w-screen max-w-xs sm:px-0" :class="bodyClass">
        <div class="rounded-b-md border-t border-gray-100">
          <div class="rounded-b-md shadow-md overflow-hidden">
            <div class="z-20 relative grid gap-5 bg-white px-5 py-5">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    openMenu: {
      type: Boolean,
      default: false
    },
    slotPassed: {
      type: Boolean,
      default: false
    },
    bodyClass: {
      type: String
    }
  }
}
</script>

<style></style>
